import React from 'react';
import AttachmentIcon from '@atlaskit/icon/glyph/attachment';
import classNames from 'classnames';
import './email-attachment.scss';
export interface EmailAttachmentProps {
  attachmentLink: string;
  fileName?: string;
  isDesignIteration1Enabled?: boolean;
}

export const EmailAttachment = ({
  attachmentLink,
  fileName,
  isDesignIteration1Enabled = false,
}: EmailAttachmentProps) => {
  return (
    <td
      className={classNames('email-attachment', {
        'email-attachment-v2': isDesignIteration1Enabled,
      })}
    >
      <span>
        <a className={'attachment-link'} href={attachmentLink} target={'_blank'} title={fileName}>
          <AttachmentIcon label="" size="medium" testId="email-attachment-icon" />
        </a>
      </span>
    </td>
  );
};
